export const getSingleOrMultiple = (num: number, single: string, multiple: string) => {
  if (num === 1 || (num % 10 === 1 && num % 100 !== 11)) {
    return single;
  }
  return multiple;
};
